import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { AnoSafra } from 'src/app/classes/AnoSafra'
import { NgForm, NgModel } from '@angular/forms'
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component'
import { UtilsService } from 'src/app/utils/utils.service'
import { StorageService } from 'src/app/services/storage.service'
import Swal from 'sweetalert2'
import { CultivarService } from 'src/app/services/cultivar.service'
import { Cultivar } from 'src/app/classes/Cultivar'
import { Cultura } from 'src/app/classes/Cultura'
@Component({
  selector: 'app-forms-cultivar',
  templateUrl: './forms-cultivar.component.html',
  styleUrls: ['./forms-cultivar.component.scss']
})
export class FormsCultivarComponent implements OnInit {

  @ViewChild('Modal', { static: false }) modal: UiModalComponent
  @ViewChild('formulario', { static: false }) formulario!: NgForm;
  @Output() finalizarSave: EventEmitter<void> = new EventEmitter()
  @Output() changeCultura: EventEmitter<boolean | void> = new EventEmitter()
  @Output() changeCultivarPadrao: EventEmitter<void> = new EventEmitter()
  @Input() culturas: Cultura[] = []
  @Input() cultivaresPorCultura: Cultivar[] = []
  @Input() isSuper: boolean = false


  isSubmit: boolean = false
  cultivar: Cultivar = new Cultivar()
  carregando: boolean = false
  int32MaxValue = 2147483647;

  constructor(
    private utils: UtilsService,
    private cultivarService: CultivarService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {}

  abrirModal(cultivar: Cultivar = null): void {
    console.debug('cultivar', cultivar)
    if(cultivar == null && !this.utils.verificarPermissaoUsuario('IncluirVariedade'))
      return;
    if (cultivar != null){
      this.cultivar = cultivar
      this.changeCultura.emit(true)
    }
    else
      this.cultivar = new Cultivar()

    this.modal.show()
  }

  fecharModal(): void {
    this.modal.hide()
    this.isSubmit = false
    this.formulario.resetForm();
  }

  isCampoInvalido(campo: NgModel): boolean {
    return (
      !campo.valid &&
      (campo.dirty || campo.touched || this.isSubmit)
);
  }

  changeCulturaValidade(): void{
    this.cultivar.CultivarBaseId = null;
    this.changeCultura.emit()
  }

  save(): void {
    console.debug(this.cultivar)
    this.carregando = true

    if (!this.validarForm()) return

    this.cultivar.UsuarioCadastro = null
    this.cultivar.UsuarioAlteracao = null
    if (this.cultivar.Id) {
      this.cultivarService
        .putCultivar(this.cultivar.Id, this.cultivar)
        .subscribe(
          (res) => {
            this.finalizarSaveRequestSuccess(
              'Variedade alterada com sucesso!',
            )
          },
          (err) => {
            this.finalizarRequestError(err)
          },
        )
    } else {
      this.cultivarService.postCultivar(this.cultivar).subscribe(
        (res) => {
          this.finalizarSaveRequestSuccess(
            'Variedade cadastrada com sucesso!',
          )
        },
        (err) => {
          this.finalizarRequestError(err)
        },
      )
    }
  }

    confirmExcluirCultivar(cultivar: Cultivar): void{
      if(!this.utils.verificarPermissaoUsuario('ExcluirVariedade'))
        return;
      Swal.fire({
        title: 'Você tem certeza desta ação?',
        text:
          'Deseja excluir esta Variedade?. Essa ação é irreversível!',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Excluir Ano Safra',
      }).then((response) => {
        if (!response.dismiss) {
          this.excluir(cultivar)
        }
      })
    }

  excluir(cultivar: Cultivar): void{
    this.carregando = true;

    this.cultivarService.deleteCultivar(cultivar.Id).subscribe(
      res => {
        this.utils.handleSuccess("Variedade excluída com sucesso!")
        this.carregando = false;
        this.finalizarSave.emit()
      },
      err => {
        this.utils.getErro(err)
        this.carregando = false;
      }
    )
  }

  validarForm(): boolean {
    if (this.formulario.invalid) {
      this.isSubmit = true
      this.carregando = false
      this.utils.handleWarning(
        'Por favor, preencha todos os campos obrigatórios corretamente.',
      )
      return false
    }

    return true
  }

  finalizarSaveRequestSuccess(msg: string): void {
    this.utils.handleSuccess(msg)
    this.carregando = false
    this.finalizarSave.emit()
    this.fecharModal()
  }

  finalizarRequestError(error: any): void {
    this.utils.getErro(error)
    this.carregando = false
  }
}
